(ns splash.libraries.constants.build-utils
  "There is not an automatic way to import enums from the Monolith.
   It is a somewhat tedious task but this namespace should help make
   new translation additions easier and more consistent."
  (:require
    [malli.core :as m]
    [malli.error :as me]))

(def Translations
  "A translator needs at least 2 of :id, :enum, :display"
  [:vector
   [:map
    [:id {:optional true
          :description (str "The primary key in the database. "
                         "This is `optional` because missing ids imply that there is no database backing for this type. "
                         "This is `maybe` because certain Website enums explicitly assign `null` as a sentinal value.")}
     [:maybe :int]]
    [:enum {:optional true
            :description (str "The enum var name in Website. "
                           "This is `optional` because not every constant has an Enum type in Website. "
                           "This is `maybe` because even if there is an Enum, not every value may be accounted for.")}
     [:maybe :string]]
    [:display {:optional true
               :description "The display value"}
     :string]]])

(def explain-translations
  (m/explainer Translations))

(defn ->translator
  "Given a vector of maps (translations), builds a map of translators
   for easy and more performant consumption."
  [translations]
  (when-let [errors (me/humanize (explain-translations translations))]
    (throw (ex-info "Invalid Translations!" {:errors errors})))
  (let [assured-assoc-in (fn [m path value]
                           (if (some? (get-in m path))
                             (throw (ex-info "Each path must be distinct!" {:path path
                                                                            :value value}))
                             (assoc-in m path value)))]
    (reduce
      (fn [m {:keys [id enum display] :as translation}]
        (cond-> m
          (contains? translation :id)
          (->
            (assured-assoc-in [:id id :enum] enum)
            (assured-assoc-in [:id id :display] display))

          (contains? translation :enum)
          (->
            (assured-assoc-in [:enum enum :id] id)
            (assured-assoc-in [:enum enum :display] display))

          (contains? translation :display)
          (->
            (assured-assoc-in [:display display :enum] enum)
            (assured-assoc-in [:display display :id] id))))
      {}
      translations)))

(defn build-enum-map
  "Builds a map of enums from the provided data
   `id->enum` -      Copy/paste from Website code with some manual find/replace
                     and should be a map of enum -> id
   `database-json` - Copy/paste or export a `gradschoolloans` enums table to JSON

   NOTE: This lib purposely has minimal dependencies so conversion to EDN needs to happen in a REPL."
  [id->enum database-map]
  (->> database-map
    (reduce
      (fn [coll {:strs [id type]}]
        (conj coll {:id id
                    :enum (get id->enum id)
                    :display type}))
      [])
    (sort-by :id)
    vec))

(comment
  (let [monolith-enums {1 "Associate", 2 "Bachelors", 3 "Graduate", 4 "NoDegree"}
        database-json  [{"id" 1, "type" "Associate"}
                        {"id" 2, "type" "Bachelor's"}
                        {"id" 3, "type" "Graduate"}
                        {"id" 4, "type" "No Degree"}]]
    (build-enum-map monolith-enums database-json))
  :rcf)

(comment
  ;; When making new constant namespaces, this can help quickly create defs for each ID.
  ;; Dependency purposely not added to BUILD.bazel
  (require '[camel-snake-kebab.core :as csk])
  #?(:clj
     (defn make-defs
       "Will print a series of defs for each ID.
        Then print a series of map constants that contain the var.

        Copy/paste, then find/replace to delete any semicolons that print from your editor"
       [constants]
       (doseq [{:keys [enum id]} constants]
         (println (format "(def ^:const %s %s)" (csk/->kebab-case-symbol enum) id)))

       (doseq [{:keys [enum display]} constants]
         (let [sym (csk/->kebab-case-symbol enum)]
           (println
             (format "{:id      %s\n :enum    \"%s\"\n :display \"%s\"}" sym enum display))))))

  )
